<template>
  <v-flex xs12 px-3 style="width: 100vw;" class="stockListContainer">
    <v-flex xs12>
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="gotoProductionOverview" class="breadCrumb breadCrumbWide">
        Production overview
      </v-btn>
      <v-btn @click="gotoStockList" class="breadCrumb">
        Stock list
      </v-btn>
      <div style="display: inline; float: right;">
        <v-btn @click="selectSummary" class="btnToggleFilter" v-if="showSummaryButton" style="margin-right: 50px;">
          Summary
        </v-btn>
        <v-btn @click="selectDetails" class="btnToggleFilter" v-if="showDetailsButton" style="margin-right: 50px;">
          Details
        </v-btn>
        <div style="width: 50px; display: inline-flex;" v-if="showPallets"></div>
        <v-btn @click="selectInStock" class="btnToggleFilter" :disabled="isModeInStock" v-if="showPallets">
          In stock
        </v-btn>
        <v-btn @click="selectRepacked" class="btnToggleFilter" style="margin-right: 50px;" :disabled="isModeRepacked" v-if="showPallets">
          Repacked
        </v-btn>
        <div style="width: 50px; display: inline-flex;" v-if="showPallets"></div>
        <v-btn @click="pdfReport" class="btnPrintReport" :disabled="!canExportPallets" v-if="showPallets">Print</v-btn>
        <v-btn @click="excelReport" class="btnPrintReport" :disabled="!canExportPallets" v-if="showPallets">Excel</v-btn>
        <v-btn @click="savePallet" class="savePallet" :disabled="!canSavePallet" v-if="editPallet">Save</v-btn>
        <v-btn @click="cancelPallet" class="cancelPallet" v-if="editPallet">Cancel</v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-container fluid py-2 px-3 v-if="showPallets">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <v-container fluid pa-0>
            <v-layout wrap>
              <v-flex text-xs-left xs12 md2 px-2>
                <v-text-field v-model="search" append-icon="search" placeholder="Search" style="padding-bottom: 0 !important;" class="search"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;" v-if="isModeInStock">
                <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object class="supplierFilter" @change="filterPallets"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;" v-if="isModeInStock">
                <v-select :items="filterLocations" v-model="filterLocation" item-text="nameAndText" prepend-icon="a-address" return-object class="locationFilter" @change="filterPallets"/>
              </v-flex>
              <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;" v-if="isModeInStock">
                <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object class="categoryFilter" @change="filterPallets">
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-data-table :headers="showSupplier ? headersWithSupplier : headers" :items="pallets" v-model="filteredPallets" :search="search" ref="pallets" hide-actions class="stockListTable" v-show="pallets && pallets.length > 0 && !summary">
                <template v-slot:items="props">
                  <tr @click="canEditPallet(props.item) ? selectPallet(props.item) : null" :class="canEditPallet(props.item) ? 'selectable' : ''">
                    <td class="text-xs-left" style="padding-top: 4px !important;">{{ props.item.number }}</td>
                    <td class="text-xs-left" style="padding-top: 4px !important;">{{ props.item.externalNumber }}</td>
                    <td class="text-xs-left nowrap palletItems" style="vertical-align: middle !important;">
                      <PalletItems :items="props.item.items" no-planned-amount="true" color-size="16" color-radius="3"/>
                    </td>
                    <td class="text-xs-left nowrap" style="padding-top: 4px !important;" v-if="showSupplier">{{ props.item.supplierName }}</td>
                    <td class="text-xs-left nowrap" style="padding-top: 4px !important;">{{ props.item.fieldName }}</td>
                    <td class="text-xs-left nowrap" style="padding-top: 4px !important;">{{ props.item.locationName }}</td>
                  </tr>
                </template>
              </v-data-table>

              <v-data-table :headers="summaryHeaders" :items="summaries" v-model="filteredSummaries" :search="search" ref="palletSummaries" hide-actions class="stockListTable" v-show="summaries && summaries.length > 0 && summary">
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-right" style="padding-top: 4px !important; width: 80px; padding-right: 30px !important;">{{ props.item.amount }}</td>
                    <td class="text-xs-left nowrap palletItems" style="vertical-align: middle !important; width: 500px;">
                      <PalletItems :items="props.item.items" no-planned-amount="true" no-amount="true" color-size="16" color-radius="3"/>
                    </td>
                    <td class="text-xs-left nowrap" style="padding-top: 4px !important;">{{ props.item.locationName }}</td>
                  </tr>
                </template>
              </v-data-table>

              <v-flex xs12 style="padding-top: 20px; text-align: center; font-weight: bold;" v-if="pallets.length === 0">
                No pallets found
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <Panel :title="'Pallet' + (currentPallet.number ? ' #' + currentPallet.number : '')" no-margin="true" class="palletPanel" v-if="editPallet">
      <PanelColumn>
        <table class="editTable">
          <tr>
            <td style="padding-right: 100px;">
              <div class="label">External pallet no.</div>
            </td>
            <td>
              <v-text-field class="externalPalletNumberInput" v-model="currentPallet.externalNumber" solo flat :maxlength="20"/>
            </td>
          </tr>
        </table>
      </PanelColumn>
      <PanelColumn style="padding-top: 20px;">
        <table class="editTable">
          <tr style="border-bottom: 1px solid lightgrey;">
            <td style="width: 35px; padding-right: 0; border-bottom: 1px solid lightgrey;"></td>
            <td style="padding-top: 10px; border-bottom: 1px solid lightgrey;">
              <div class="label">Category</div>
            </td>
            <td style="padding-top: 10px; border-bottom: 1px solid lightgrey;">
              <div class="label">Amount</div>
            </td>
          </tr>
          <tr>
            <td colspan="3" style="height: 10px;"></td>
          </tr>
          <tr v-for="(item) in currentPallet.items" :key="'i_' + item.id">
            <td style="width: 35px; padding-right: 0;">
              <div v-if="item.category && item.category.id > 0 && !(item.category.color.secondColor && item.category.color.secondColor !== '')" :style="'width: 25px; height: 25px; background-color: #' + item.category.color.color + '; border: 1px solid #cccccc; display: table-cell;'"></div>
              <div v-if="item.category && item.category.id > 0 && item.category.color.secondColor && item.category.color.secondColor !== ''" :style="'width: 25px; height: 25px; background: repeating-linear-gradient(-45deg, #' + item.category.color.color + ', #' + item.category.color.color + ' 3px, #' + item.category.color.secondColor + ' 3px, #' + item.category.color.secondColor + ' 6px); border: 1px solid #cccccc; display: table-cell;'"></div>
            </td>
            <td style="padding-right: 100px;">
              <div class="label">{{ item.category ? item.category.label : item.categoryName ? item.categoryName : '' }}{{ itemOptions(item) }}</div>
            </td>
            <td :key="'value_' + item.id">
              <v-text-field class="itemAmountInput alignRight" v-model="item.amount" solo flat/>
            </td>
          </tr>
        </table>
      </PanelColumn>
    </Panel>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import LoaderPallet from '../components/LoaderPallet'
import PanelColumn from '../components/PanelColumn'
import PalletItems from './PalletItems'
import ErrorDialog from '../components/ErrorDialog'
import axios from 'axios'
import NumberUtil from '@/assets/javascript/numberutil'

export default {
  name: 'StockList',
  components: { Panel, LoaderPallet, PanelColumn, PalletItems, ErrorDialog },
  data () {
    return {
      mode: 'IN_STOCK',
      allPallets: [],
      pallets: [],
      filteredPallets: [],
      summaries: [],
      filteredSummaries: [],
      suppliers: [],
      currentPallet: null,
      summary: true,
      search: '',
      exportPalletsUpdateCounter: 1,
      filterSuppliers: [],
      filterSupplier: { id: 0 },
      filterFields: [],
      filterField: { id: 0 },
      filterCategories: [],
      filterCategory: { id: 0 },
      filterLocations: [],
      filterLocation: { id: 0 },
      headers: [
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'Extern pallet no.', value: 'externalNumber', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Field', value: 'fieldName', sortable: false },
        { text: 'Location', value: 'locationName', sortable: false }
      ],
      headersWithSupplier: [
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'Extern pallet no.', value: 'externalNumber', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Supplier', value: 'supplierName', sortable: false },
        { text: 'Field', value: 'fieldName', sortable: false },
        { text: 'Location', value: 'locationName', sortable: false }
      ],
      summaryHeaders: [
        { text: 'Amount', value: 'amount', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Location', value: 'locationName', sortable: false }
      ]
    }
  },
  created: function () {
    this.gotoStockList()
  },
  computed: {
    showPallets: function () {
      return this.pallets && !this.currentPallet
    },
    showSummaryButton: function () {
      return this.showPallets && this.isModeInStock && !this.summary
    },
    showDetailsButton: function () {
      return this.showPallets && this.isModeInStock && this.summary
    },
    showSupplier: function () {
      return this.suppliers && this.suppliers.length > 1
    },
    hasPallets: function () {
      return this.pallets && this.pallets.length
    },
    isModeInStock: function () {
      return this.mode === 'IN_STOCK'
    },
    isModeRepacked: function () {
      return this.mode === 'REPACKED'
    },
    editPallet: function () {
      return this.currentPallet
    },
    canSavePallet: function () {
      if (this.currentPallet) {
        if (this.currentPallet.items && this.currentPallet.items.length) {
          for (let item of this.currentPallet.items) {
            if (!NumberUtil.isZeroOrPositiveInteger(item.amount)) {
              return false
            }
          }
        }
        return true
      }
      return false
    },
    canExportPallets: function () {
      let filteredItems = this.exportPalletsUpdateCounter && this.$refs.pallets ? this.$refs.pallets.filteredItems : null
      return !this.summary && (!filteredItems || filteredItems.length > 0)
    }
  },
  methods: {
    gotoFrontPage () {
      this.$emit('goHome')
    },
    gotoProductionOverview () {
      this.$emit('goProductionOverview')
    },
    gotoStockList () {
      this.selectInStock()
    },
    selectInStock () {
      this.mode = 'IN_STOCK'
      this.loadPallets()
    },
    selectRepacked () {
      this.mode = 'REPACKED'
      this.summary = false
      this.loadPallets()
    },
    selectSummary () {
      this.summary = true
    },
    selectDetails () {
      this.summary = false
    },
    loadPallets () {
      if (this.mode === 'REPACKED') {
        this.loadPalletsRepacked()
      } else {
        this.loadPalletsInStock()
      }
    },
    async loadPalletsInStock () {
      this.allPallets = []
      this.pallets = []
      this.suppliers = []
      this.filterSuppliers = []
      this.filterFields = []
      this.filterCategories = []
      this.filterLocations = []
      await axios.get('/backend/rest/pallet/stock_list/IN_STOCK')
        .then(response => {
          let pallets = response.data
          this.loadSuppliers(pallets)
          this.loadFields(pallets)
          this.loadCategories(pallets)
          this.loadLocations(pallets)
          this.processPallets(pallets)
          this.allPallets = pallets
          this.filterPallets()
        })
    },
    loadPalletsRepacked () {
      this.allPallets = []
      this.pallets = []
      this.suppliers = []
      axios.get('/backend/rest/pallet/stock_list/REPACKED')
        .then(response => {
          let pallets = response.data
          this.loadSuppliers(pallets)
          this.processPallets(pallets)
          this.allPallets = pallets
          this.pallets = pallets
        })
    },
    loadSuppliers (pallets) {
      let suppliers = []
      if (pallets && pallets.length) {
        for (let pallet of pallets) {
          if (suppliers.filter(s => s.id === pallet.supplier.id).length === 0) {
            suppliers.push(pallet.supplier)
          }
        }
      }
      this.suppliers = suppliers
      this.filterSuppliers = JSON.parse(JSON.stringify(suppliers))
      this.filterSuppliers.splice(0, 0, {
        id: 0,
        name: ''
      })
      this.filterSuppliers.sort(function (f1, f2) {
        return f1.name.toLowerCase().localeCompare(f2.name.toLowerCase())
      })
    },
    loadFields (pallets) {
      this.filterFields = []
      if (pallets && pallets.length) {
        for (let pallet of pallets) {
          if (pallet.field) {
            if (this.filterFields.filter(f => f.id === pallet.field.id).length === 0) {
              pallet.field.supplierId = pallet.supplier ? pallet.supplier.id : 0
              this.filterFields.push(pallet.field)
            }
          }
        }
      }
      this.filterFields.splice(0, 0, {
        id: 0,
        address: {
          nameAndText: ''
        }
      })
      this.filterFields.sort(function (f1, f2) {
        return f1.address.nameAndText.toLowerCase().localeCompare(f2.address.nameAndText.toLowerCase())
      })
    },
    loadCategories (pallets) {
      this.filterCategories = []
      if (pallets && pallets.length) {
        for (let pallet of pallets) {
          if (pallet.items && pallet.items.length) {
            for (let item of pallet.items) {
              if (item.category && this.filterCategories.filter(c => c.id === item.category.id).length === 0) {
                this.filterCategories.push(item.category)
              }
            }
          }
        }
      }
      this.filterCategories.splice(0, 0, {
        id: 0,
        displayLabel: '',
        sortableLabel: ''
      })
      this.filterCategories.sort(function (f1, f2) {
        return f1.sortableLabel.localeCompare(f2.sortableLabel)
      })
    },
    loadLocations (pallets) {
      this.filterLocations = []
      if (pallets && pallets.length) {
        for (let pallet of pallets) {
          if (pallet.location && this.filterLocations.filter(a => a.id === pallet.location.id).length === 0) {
            this.filterLocations.push(pallet.location)
          }
        }
      }
      this.filterLocations.splice(0, 0, {
        id: 0,
        nameAndText: ''
      })
      this.filterLocations.sort(function (a1, a2) {
        return a1.nameAndText.toLowerCase().localeCompare(a2.nameAndText.toLowerCase())
      })
    },
    filterPallets () {
      this.pallets = []
      if ((this.filterSupplier && this.filterSupplier.id > 0) || (this.filterLocation && this.filterLocation.id > 0) || (this.filterCategory && this.filterCategory.id > 0)) {
        let filteredPallets = []
        if (this.allPallets && this.allPallets.length) {
          for (let pallet of this.allPallets) {
            let include = true
            if (this.filterSupplier && this.filterSupplier.id > 0 && pallet.supplier.id !== this.filterSupplier.id) {
              include = false
            }
            if (include && this.filterLocation && this.filterLocation.id > 0 && (!pallet.location || pallet.location.id !== this.filterLocation.id)) {
              include = false
            }
            if (include && this.filterCategory && this.filterCategory.id > 0) {
              include = false
              if (pallet.items && pallet.items.length) {
                for (let item of pallet.items) {
                  if (item.category && item.category.id === this.filterCategory.id) {
                    include = true
                  }
                }
              }
            }
            if (include) {
              filteredPallets.push(pallet)
            }
          }
        }
        this.pallets = filteredPallets
      } else {
        this.pallets = this.allPallets
      }
      this.createSummary()
    },
    processPallets (pallets) {
      if (pallets && pallets.length) {
        for (let pallet of pallets) {
          pallet.supplierName = pallet.supplier.name
          pallet.fieldName = this.getFieldName(pallet)
          pallet.locationName = this.getLocationName(pallet)

          let categories = ''
          let categoriesWithoutAmount = ''
          if (pallet.items && pallet.items.length) {
            for (let item of pallet.items) {
              if (item.category) {
                categories += item.category.label + ' '
                categoriesWithoutAmount += item.category.label + ' '
              } else if (item.categoryName) {
                categories += item.categoryName + ' '
                categoriesWithoutAmount += item.categoryName + ' '
              }
              if (item.options && item.options.length > 0) {
                for (let option of item.options) {
                  categories += option.name + ' '
                  categoriesWithoutAmount += option.name + ' '
                }
              }
              if (item.amount && item.amount !== 0) {
                categories += item.amount + 'pcs '
              }
            }
          }
          pallet.categories = categories
          pallet.categoriesWithoutAmount = categoriesWithoutAmount
        }
      }
    },
    createSummary () {
      this.summaries = []
      let summaries = {}
      if (this.pallets && this.pallets.length) {
        for (let pallet of this.pallets) {
          if (pallet.categoriesWithoutAmount && pallet.categoriesWithoutAmount !== '' && pallet.locationName && pallet.locationName !== '') {
            let key = pallet.categoriesWithoutAmount + '|' + pallet.locationName
            let summary = summaries[key]
            if (!summary) {
              summary = {
                amount: 0,
                categories: pallet.categoriesWithoutAmount,
                items: pallet.items,
                locationName: pallet.locationName
              }
            }
            summary.amount++
            summaries[key] = summary
          }
        }
        for (let categories in summaries) {
          let summary = summaries[categories]
          this.summaries.push({
            amount: summary.amount,
            items: summary.items,
            categories: summary.categories,
            locationName: summary.locationName
          })
        }
      }
      // this.summaries = summaries
    },
    getFieldName (pallet) {
      if (pallet && pallet.field) {
        if (pallet.field.displayName && pallet.field.displayName !== '') {
          return pallet.field.displayName
        }
        if (pallet.field.address) {
          if (pallet.field.address.name && pallet.field.address.name !== '') {
            return pallet.field.address.name
          }
          if (pallet.field.address.text && pallet.field.address.text !== '') {
            return pallet.field.address.text
          }
        }
      }
      return ''
    },
    getLocationName (pallet) {
      if (pallet && pallet.location) {
        if (pallet.location.name && pallet.location.name !== '') {
          return pallet.location.name
        }
        if (pallet.location.text && pallet.location.text !== '') {
          return pallet.location.text
        }
      }
      return ''
    },
    excelReport () {
      let filteredItems = this.$refs.pallets.filteredItems
      let palletIds = []
      for (let pallet of filteredItems) {
        palletIds.push(pallet.id)
      }
      let params = 'pallets=' + palletIds.join(',')
      params += '&filterGroup=' + this.mode

      axios.post('/backend/report/stockList', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/vnd.ms-excel' }), 'Stock list.xlsx')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Stock list.xlsx')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    pdfReport () {
      let filteredItems = this.$refs.pallets.filteredItems
      let palletIds = []
      for (let pallet of filteredItems) {
        palletIds.push(pallet.id)
      }
      let params = 'pallets=' + palletIds.join(',')
      params += '&title=Stock list'
      params += '&filterGroup=' + this.mode

      axios.post('/backend/print/stockList.xhtml', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/pdf' }), 'Stock list.pdf')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Stock list.pdf')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    selectPallet (pallet) {
      this.currentPallet = pallet
    },
    async savePallet () {
      let updated = false
      let pallet = JSON.parse(JSON.stringify(this.currentPallet))
      delete pallet.supplierName
      delete pallet.fieldName
      delete pallet.locationName
      delete pallet.categories
      await axios.post('/backend/rest/pallet/stock_list/update_pallet', pallet)
        .then(response => {
          updated = true
        })

      if (updated) {
        await this.loadPalletsInStock()
        this.cancelPallet()
      }
    },
    cancelPallet () {
      this.currentPallet = null
    },
    canEditPallet (pallet) {
      return pallet.state !== 'REPACKED'
    },
    itemOptions (item) {
      let getOptionsAsString = ''
      if (item.options && item.options.length > 0) {
        getOptionsAsString += ' ('
        for (let i = 0; i < item.options.length; i++) {
          if (i > 0) {
            getOptionsAsString += ', '
          }
          getOptionsAsString += item.options[i].name
        }
        getOptionsAsString += ')'
      }
      return getOptionsAsString
    }
  },
  watch: {
    search (val) {
      this.exportPalletsUpdateCounter++
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .breadCrumb {
    height: 30px !important;
    padding: 0 20px !important;
    margin-right: 6px !important;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 15px !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  div.stockList table,
  table.stockList {
    width: 100%;
    border-collapse: collapse;
  }
  div.stockList table tr th,
  table.stockList tr th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 20px 2px 5px;
  }
  div.stockList table tr td,
  table.stockList tr td {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 20px 2px 5px;
    cursor: pointer;
  }
  div.stockList table tr:hover,
  table.stockList tr:hover {
    background-color: #F0F0F0;
  }
  div.label {
    font-size: 15px;
    font-weight: bold;
    line-height: 40px;
  }
  div.externalPalletNumberInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    min-width: 125px;
    width: 160px;
    cursor: pointer;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  div.itemAmountInput {
    border: 1px solid #004d40;
    border-radius: 5px;
    height: 40px;
    min-width: 75px;
    width: 75px;
    cursor: pointer;
    line-height: 40px;
    text-align: right;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  div.itemAmountInput > .v-input__control > .v-input__slot > .v-text-field__slot > input {
    text-align: right;
  }
  .editTable {
    border-collapse: collapse;
  }
  .editTable tr td {
    padding: 3px 40px 3px 0;
    white-space: nowrap;
  }
  div.shipmentTable {
    width: 100%;
  }
  div.shipmentTable .v-table tr td {
    font-size: 13px !important;
  }
  div.stockList table tr td.palletItems table.palletItems tr td {
    vertical-align: middle !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/StockList.vue